'use strict';

var createFilters = require('./resize_filter_gen');
var _require = require('./convolve'),
  convolveHor = _require.convolveHor,
  convolveVert = _require.convolveVert,
  convolveHorWithPre = _require.convolveHorWithPre,
  convolveVertWithPre = _require.convolveVertWithPre;
function hasAlpha(src, width, height) {
  var ptr = 3,
    len = width * height * 4 | 0;
  while (ptr < len) {
    if (src[ptr] !== 255) return true;
    ptr = ptr + 4 | 0;
  }
  return false;
}
function resetAlpha(dst, width, height) {
  var ptr = 3,
    len = width * height * 4 | 0;
  while (ptr < len) {
    dst[ptr] = 0xFF;
    ptr = ptr + 4 | 0;
  }
}
module.exports = function resize(options) {
  var src = options.src;
  var srcW = options.width;
  var srcH = options.height;
  var destW = options.toWidth;
  var destH = options.toHeight;
  var scaleX = options.scaleX || options.toWidth / options.width;
  var scaleY = options.scaleY || options.toHeight / options.height;
  var offsetX = options.offsetX || 0;
  var offsetY = options.offsetY || 0;
  var dest = options.dest || new Uint8Array(destW * destH * 4);
  var filter = typeof options.filter === 'undefined' ? 'mks2013' : options.filter;
  var filtersX = createFilters(filter, srcW, destW, scaleX, offsetX),
    filtersY = createFilters(filter, srcH, destH, scaleY, offsetY);
  var tmp = new Uint16Array(destW * srcH * 4);

  // Autodetect if alpha channel exists, and use appropriate method
  if (hasAlpha(src, srcW, srcH)) {
    convolveHorWithPre(src, tmp, srcW, srcH, destW, filtersX);
    convolveVertWithPre(tmp, dest, srcH, destW, destH, filtersY);
  } else {
    convolveHor(src, tmp, srcW, srcH, destW, filtersX);
    convolveVert(tmp, dest, srcH, destW, destH, filtersY);
    resetAlpha(dest, destW, destH);
  }
  return dest;
};